<template>
  <select
    v-model="selected"
    :disabled="disabled"
    class="
      tw-bg-select-caret
      tw-bg-no-repeat
      tw-bg-right
      tw-appearance-none
      tw-text-sm
      tw-leading-none
      tw-w-full
      hover:tw-border-sf-gray-light
      focus:tw-border-sf-primary-dark focus:tw-outline-none focus:tw-shadow-none
      active:tw-border-sf-primary-dark
      active:tw-outline-none
      active:tw-shadow-none
      disabled:tw-border-sf-snow-darker
      disabled:tw-text-sf-gray-lighter
      disabled:tw-bg-sf-neutral-subtle-1
      tw-transition-all
    "
  >
    <option
      v-for="option in options"
      :key="`${option.label}_${option.value}`"
      :value="option.value"
      :disabled="option.disabled"
    >
      {{ option.label }}
    </option>
  </select>
</template>

<script
  setup
  lang="ts"
  generic="V extends string | number | null | undefined, O extends {
  value: V
  label: string
  disabled?: boolean
}"
>
import { useVModel } from '@vueuse/core'

const props =
  defineProps<{
    options: O[]
    modelValue: V
    // Closes the whole control. An option can also be closed off on its own —
    // `disabled` on the option type above — so a caller can keep a value on
    // screen while ruling it out.
    disabled?: boolean
  }>()

const emit =
  defineEmits<{
    'update:modelValue': [value: V]
  }>()

const selected = useVModel(props, 'modelValue', emit, {
  passive: true,
  deep: true,
})
</script>
